import envList from '../../../constants/envList';
import ProductType from '../../../constants/ProductType';
import RtPlusService from '../../../services/rtPlusService';

function prepareState(res, preselect, isoValue, env, r) {
  switch (env) {
    case envList.CA.path:
    case envList.IME.path: {
      const {
        adhesifPrice,
        adhesifRTPlusXL,
        adhesifs,
        entreChevronsItem,
        entreChevronsRtPlusFiltered,
        manchonsPrice,
        masticPrice,
        mastics,
        selectedAdhesif,
        sousChevronsItem,
        sousChevronsRtplusFiltered,
        suspentesItem: selectedSuspentes,
        suspentesRtplus,
      } = RtPlusService.getProducts(res, preselect, isoValue, env);

      const costs = RtPlusService.calculateCost([
        {
          type: ProductType.BETWEEN_CHEVRON,
          productData: entreChevronsItem,
        },
        {
          type: ProductType.UNDER_CHEVRON,
          productData: sousChevronsItem,
        },
        {
          type: ProductType.MANCHON,
          productData: {
            quantity: (isoValue * 2.5) / 50,
            price: manchonsPrice,
          },
        },
        {
          type: ProductType.SHROUD,
          productData: selectedSuspentes,
        },
        {
          type: ProductType.ADHESIVE,
          productData: selectedAdhesif,
        },
        {
          type: ProductType.MASTIC,
          productData: {
            quantity: Math.ceil((isoValue * 0.5) / 12),
            price: masticPrice,
          },
        },
      ], isoValue);

      const {
        betweenChevron,
        underChevron,
        manchon: manchonCost,
        shroud,
        adhesive,
        solidouble,
        mastic: masticCost,
      } = costs;

      return {
        ...adhesive,
        ...betweenChevron,
        ...manchonCost,
        ...masticCost,
        ...shroud,
        ...solidouble,
        ...underChevron,
        adhesifPriceRtplus: adhesifPrice,
        adhesifs,
        adhesifXlPriceRtplus: adhesifRTPlusXL,
        entreChevronsItem,
        entreChevronsOptions: entreChevronsRtPlusFiltered,
        manchonRtplusPrice: manchonsPrice,
        masticPrice,
        masticrtplusPrice: mastics,
        modalRtPlusMonocoucheOpen: false,
        modalRtPlusMonocoucheOpen60: false,
        modalRtPlusMonocoucheOpen80: false,
        selectedAdhesif,
        sousChevronsItem,
        sousChevronsOptions: sousChevronsRtplusFiltered,
        selectedSuspentes,
        suspentesOptionsRtplus: suspentesRtplus,
      };
    }
    case envList.CP.path: {
      const {
        adhesives,
        insulators,
        mastics,
        membranes,
        selectedAdhesive,
        selectedInsulator,
        selectedMastic,
        selectedMembrane,
        selectedSuspentes,
        suspentes,
      } = RtPlusService.getProducts(res, preselect, isoValue, env, r);

      const {
        insulatorBlown,
        mastic,
        membrane,
        shroud,
        adhesive,
      } = RtPlusService.calculateCost([
        {
          type: ProductType.INSULATOR_BLOWN,
          productData: selectedInsulator,
        },
        {
          type: ProductType.MASTIC,
          productData: selectedMastic,
        },
        {
          type: ProductType.SHROUD,
          productData: selectedSuspentes,
        },
        {
          type: ProductType.ADHESIVE,
          productData: selectedAdhesive,
        },
        {
          type: ProductType.MEMBRANE,
          productData: selectedMembrane,
        },
      ],
      isoValue,
      env,
      );

      return {
        adhesives,
        insulators,
        mastics,
        membranes,
        selectedAdhesive,
        selectedInsulator,
        selectedMastic,
        selectedMembrane,
        selectedSuspentes,
        suspentes,
        ...insulatorBlown,
        ...mastic,
        ...membrane,
        ...shroud,
        ...adhesive,
      };
    }
    default:
      return {};
  }
}

export {
  prepareState,
};



// WEBPACK FOOTER //
// ./src/components/Protected/rtplus/utils.js